import { useTranslation } from 'react-i18next';

export default function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <div className="page-loading">
      <div className="spinner spinner-lg" />
      <span>{t('common.loading')}</span>
    </div>
  );
}
